"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// Additional Documentation
// Docs: https://github.com/reverbdotcom/docs/blob/master/tech/user-context-provider.md
var React = require("react");
var PropTypes = require("prop-types");
var user = PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
    isAdmin: PropTypes.bool,
    isActivated: PropTypes.bool,
    isBusiness: PropTypes.bool,
    preferredSeller: PropTypes.bool,
    isBot: PropTypes.bool,
    loggedOut: PropTypes.bool,
    cookieId: PropTypes.string,
    requestId: PropTypes.string,
    country: PropTypes.string,
    countryCode: PropTypes.string,
    shippingRegionCode: PropTypes.string,
    profileSlug: PropTypes.string,
    locale: PropTypes.string,
    gdpr: PropTypes.bool,
    deviceName: PropTypes.string,
    experiments: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
        track_in_mparticle: PropTypes.bool,
        track_in_logs: PropTypes.bool,
        use_in_frontend: PropTypes.bool,
        multivariate_experiment: PropTypes.bool,
    })),
    currency: PropTypes.string,
    itemRegionOverride: PropTypes.string,
    sessionId: PropTypes.string,
});
/**
 * The UserContextProvider injects the current user into your component via React's context API.
 * Any component in the render tree (every component in this repo) can ask for that specific field
 * on the context (called user). To opt a component into using this field, you must use the
 * `withUserContext` HOC.
 *
 * class MyComponent extends React.Component {
 *  render() {
 *    return <p>{this.context.user.name}</p>
 *  }
 * }
 *
 * export default withUserContext(MyComponent);
 */
var UserContextProvider = /** @class */ (function (_super) {
    tslib_1.__extends(UserContextProvider, _super);
    function UserContextProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserContextProvider.prototype.getChildContext = function () {
        return { user: this.props.user };
    };
    UserContextProvider.prototype.render = function () {
        return React.createElement("div", null, this.props.children);
    };
    UserContextProvider.childContextTypes = { user: user };
    return UserContextProvider;
}(React.Component));
exports.UserContextProvider = UserContextProvider;
/**
 * DEPRECATED!! Does not work with HOCs
 *
 * @WithUserContext adds the current user to your components' context.
 * You can query this field by adding this decorator to your component, which
 * will inject the `user` field onto `this.context`
 */
function WithUserContext(target) {
    target.contextTypes = target.contextTypes || {};
    target.contextTypes.user = user;
    return target;
}
exports.WithUserContext = WithUserContext;
/**
 * HOC: withUserContext adds the current user to your components' props.
 * Previously, we used a decorator, that has been deprecated.
 */
function withUserContext(Component) {
    var _a;
    var result = (_a = /** @class */ (function (_super) {
            tslib_1.__extends(Connected, _super);
            function Connected() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Connected.prototype.render = function () {
                return React.createElement(Component, tslib_1.__assign({ user: this.context.user }, this.props));
            };
            return Connected;
        }(React.Component)),
        _a.displayName = "withUserContext(" + (Component.displayName || Component.name) + ")",
        _a.WrappedComponent = Component,
        _a.contextTypes = {
            user: user,
        },
        _a);
    return result;
}
exports.withUserContext = withUserContext;
//# sourceMappingURL=user_context_provider.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/user_context_provider.js
// module id = havB
// module chunks = 20 21 22